import PropTypes from "prop-types";

import { buttonRowCss, inlineButtonRowCss } from "../Actions.style";
import CancelButton from "../CancelButton";
import DeleteButton from "../DeleteButton";
import EditButton from "../EditButton";
import SaveButton from "../SaveButton";

const AnnotationCommentActionsPropTypes = {
  annotationId: PropTypes.number,
  currentComment: PropTypes.object,
  commentDeleteButtonRef: PropTypes.object,
  handleCancel: PropTypes.func,
  showDeleteConfirmation: PropTypes.func,
  shouldShowDeleteConfirmation: PropTypes.bool,
  handleEdit: PropTypes.func,
  handleSave: PropTypes.func,
  isActionPending: PropTypes.bool,
  isCommentEditMode: PropTypes.bool,
  isLastCommentInThread: PropTypes.bool,
  isReply: PropTypes.bool,
};

const AnnotationCommentActions = ({
  annotationId,
  currentComment,
  commentDeleteButtonRef,
  handleCancel,
  handleSave,
  handleEdit,
  isActionPending,
  isCommentEditMode,
  isLastCommentInThread,
  isReply = false,
  showDeleteConfirmation,
  shouldShowDeleteConfirmation,
}) => {
  if (isReply) {
    return (
      <div css={buttonRowCss}>
        {currentComment?.text && (
          <CancelButton
            annotationId={annotationId}
            handleCancel={handleCancel}
          />
        )}
        <SaveButton
          annotationId={annotationId}
          buttonFlavor="solid"
          isActionPending={isActionPending}
          handleSave={handleSave}
          isReply
        />
      </div>
    );
  }

  if (isLastCommentInThread && !isCommentEditMode) {
    return (
      <div css={inlineButtonRowCss}>
        <DeleteButton
          annotationId={annotationId}
          buttonFlavor="incognito"
          commentDeleteButtonRef={commentDeleteButtonRef}
          handleDelete={showDeleteConfirmation}
          isAComment
          shouldShowDeleteConfirmation={shouldShowDeleteConfirmation}
        />
        <EditButton
          annotationId={annotationId}
          buttonFlavor="incognito"
          handleEdit={handleEdit}
          isAComment
          shouldShowDeleteConfirmation={shouldShowDeleteConfirmation}
        />
      </div>
    );
  }

  if (isCommentEditMode) {
    return (
      <div css={inlineButtonRowCss}>
        <CancelButton
          annotationId={annotationId}
          buttonFlavor="incognito"
          handleCancel={handleCancel}
        >
          Cancel
        </CancelButton>
        <SaveButton
          annotationId={annotationId}
          buttonFlavor="incognito"
          isActionPending={isActionPending}
          handleSave={handleSave}
          isCommentEditMode
        />
      </div>
    );
  }
};

AnnotationCommentActions.propTypes = AnnotationCommentActionsPropTypes;

export default AnnotationCommentActions;
